// extracted by mini-css-extract-plugin
export default {"dashboard-card-skeleton":"DashboardCardSkeleton_dashboard-card-skeleton__LCTYD"};